import React, { useState, useEffect } from "react";
import "./IntroAnimation.css";

const IntroAnimation = ({ onComplete }) => {
  //const greetings = ["Hello", "नमस्ते", "Hola", "Bonjour", "こんにちは", "안녕하세요", "Ciao", "राम राम"];
  //const greetings = ["Hello", "Hola", "こんにちは", "안녕하세요", "Olá", "Bonjour", "Ciao", "ਸਤ ਸ੍ਰੀ ਅਕਾਲ", "राम राम"];
  const greetings = ["Hello!", "नमस्ते", "Hola", "Bonjour", "안녕하세요", "مرحبا", "Hallo", "નમસ્તે", "আদাব", "ਸਤ ਸ੍ਰੀ ਅਕਾਲ", "राम राम"];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeState, setFadeState] = useState("fade-in");

  useEffect(() => {
    if (currentIndex >= greetings.length) {
      // All greetings shown, fade out the entire intro
      setFadeState("intro-fade-out");
      // Call onComplete after the fade-out animation (500ms) is done
      const timer = setTimeout(() => {
        onComplete();
      }, 500); // match overlayFadeOut duration in CSS
      return () => clearTimeout(timer);
    }

    // First word (Hello) and last word (राम राम) fade, middle words instant switch
    let displayDuration;
    let useFade = true;

    if (currentIndex === 0) {
      displayDuration = 800; // Hello - readable with fade
      useFade = true;
    } else if (currentIndex === greetings.length - 1) {
      displayDuration = 700; // राम राम - readable with fade
      useFade = true;
    } else {
      displayDuration = 210; // Middle words - very fast, no fade
      useFade = false;
    }

    if (useFade) {
      setFadeState("fade-in");
    } else {
      setFadeState("instant"); // No animation for middle words
    }

    const nextTimer = setTimeout(() => {
      if (useFade) {
        setFadeState("fade-out");
        setTimeout(() => {
          setCurrentIndex(currentIndex + 1);
        }, 300);
      } else {
        // Instant switch for middle words
        setCurrentIndex(currentIndex + 1);
      }
    }, displayDuration);

    return () => clearTimeout(nextTimer);
  }, [currentIndex, greetings.length, onComplete]);

  return (
    <div className={`intro-overlay ${fadeState === "intro-fade-out" ? "fade-out-overlay" : ""}`}>
      <div className="intro-content">
        {currentIndex < greetings.length && (
          <h1 className={`greeting-text ${fadeState}`}>
            {greetings[currentIndex]}
          </h1>
        )}
      </div>
    </div>
  );
};

export default IntroAnimation;
